module.exports = __webpack_public_path__ + "img/22ne.1814f439.svg";